import gql from 'graphql-tag';

export const CREATE_WORKFLOW_MUTATION = gql`
  mutation CreateWorkflow($input: CreateWorkflowInput!) {
    createWorkflow(input: $input) {
      id
      success
      message
    }
  }
`;

export const UPDATE_WORKFLOW_MUTATION = gql`
  mutation UploadWorkflow($input: UpdateWorkflowInput!) {
    updateWorkflow(input: $input) {
      success
      message
    }
  }
`;

export const GET_WORKFLOW_BY_ID = gql`
  query GetWorkflowByID($id: ID!) {
    workflow(id: $id) {
      name
      active
      description
      json
      createdOn
      modifiedOn
      lastModifiedBy {
        fullName
      }
    }
  }
`;

export const GET_WORKFLOWS = gql`
  query GetWorkflows {
    workflows {
      id
      name
      description
      active
      json
      createdOn
      modifiedOn
      lastModifiedBy {
        fullName
      }
    }
  }
`;

export const GET_EMAIL_TEMPLATES = gql`
  query GetEmailTemplates($accountId: ID!) {
    emailTemplates(accountId: $accountId) {
      emailTemplateId
      accountId
      name
      htmlContent
      tagValueMapping
      active
      createdDate
      modifiedDate
    }
  }
`;
